import { awaitTo } from '@utils/awaitTo'

// 全局工具 方法
window.Utils = {
  awaitTo,
}
